export default __webpack_public_path__ + "static/media/Search.190d6427.svg";